/*
  Hilfsfunktionen für UserHoliday im Shiftplan V2.
*/

import { parseDateValue, toIsoDate } from "../date/month";

const DEFAULT_WORKING_DAYS_PER_WEEK = 5;

function isWorkingDay(date, workingDaysPerWeek) {
  const weekday = date.getDay();
  const normalizedWorkingDays = Math.max(1, Math.min(7, Number(workingDaysPerWeek || DEFAULT_WORKING_DAYS_PER_WEEK)));

  if (normalizedWorkingDays >= 7) return true;
  if (normalizedWorkingDays === 6) return weekday !== 0;
  return weekday >= 1 && weekday <= normalizedWorkingDays;
}

function buildDayKeysBetween(startValue, endValue) {
  const start = parseDateValue(startValue);
  const end = parseDateValue(endValue || startValue);
  if (!start || !end) return [];

  const keys = [];
  for (
    let cursor = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    cursor <= end;
    cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1)
  ) {
    keys.push(toIsoDate(cursor));
  }

  return keys;
}

export function getUserHolidayDayKeys(holiday) {
  return buildDayKeysBetween(holiday?.startDate, holiday?.endDate);
}

export function countUserHolidayDays({ holidays, employeeId, days, workingDaysPerWeek } = {}) {
  const employeeKey = String(employeeId || "");
  const visibleDaysByKey = (Array.isArray(days) ? days : []).reduce((accumulator, day) => {
    const key = String(day?.key || "");
    if (key) accumulator.set(key, day);
    return accumulator;
  }, new Map());
  const hasVisibleDays = visibleDaysByKey.size > 0;
  const holidayDayKeys = new Set();

  (Array.isArray(holidays) ? holidays : []).forEach((holiday) => {
    if (String(holiday?.userId || "") !== employeeKey) return;

    getUserHolidayDayKeys(holiday).forEach((dayKey) => {
      const visibleDay = visibleDaysByKey.get(dayKey);
      if (hasVisibleDays && !visibleDay) return;

      if (workingDaysPerWeek) {
        const dayDate = parseDateValue(visibleDay?.date || dayKey);
        if (dayDate && !isWorkingDay(dayDate, workingDaysPerWeek)) return;
      }

      holidayDayKeys.add(dayKey);
    });
  });

  return holidayDayKeys.size;
}

export function groupUserHolidaysByCell({ holidays, days }) {
  const visibleDayKeys = new Set((Array.isArray(days) ? days : []).map((day) => String(day?.key || "")).filter(Boolean));

  return (Array.isArray(holidays) ? holidays : []).reduce((accumulator, holiday) => {
    const employeeId = String(holiday?.userId || "");
    if (!employeeId) return accumulator;

    getUserHolidayDayKeys(holiday).forEach((dayKey) => {
      if (visibleDayKeys.size && !visibleDayKeys.has(dayKey)) return;
      const key = `${employeeId}::${dayKey}`;
      if (!accumulator[key]) accumulator[key] = [];
      accumulator[key].push(holiday);
    });

    return accumulator;
  }, {});
}
